import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import Logo from '../assets/SSAZ Logo Horizontal.svg';
import LogoMobile from '../assets/SSAZ Logo Horizontal.svg';
import './NavHeader.css';
import BookButton from './BookButton';

const NavHeader = ({ onOpenModal }) => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) { // Change 50 to the scroll value you prefer
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavClick = () => {
    setExpanded(false); // Collapse the navbar
  };

  return (
    <Navbar
      expand="lg"
      expanded={expanded}              // Tell <Navbar> to use your state
      onToggle={(nextExpanded) => {    // This callback receives the new expanded state
        setExpanded(nextExpanded);
        console.log('Is expanded?', nextExpanded);
      }}
      className={`custom-header ${scrolled ? 'scrolled' : ''} ${expanded ? 'expanded' : ''}`}
      sticky='top'
    >
      <Container fluid>

        {/* 
          -- MOBILE HEADER (visible on small screens, hidden on lg+):
             Toggle (left), Logo (center), Phone (right)
        */}
        <div className="d-flex d-lg-none w-100 align-items-center justify-content-between">
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 p-1 order-1" />

          <Navbar.Brand href="#home" className="mx-auto order-2">
            <img
              src={LogoMobile}
              height="40"
              alt="logo"
            />
          </Navbar.Brand>

          {/* Phone icon or phone link on the right
          <div className="d-flex align-items-center justify-content-center p-2 order-3">
            <Nav.Link href="tel:+14807965133" className="p-0 text-white">
              <i className="bi bi-telephone fs-4" />
            </Nav.Link>
          </div> */}
        </div>

        {/* 
          -- DESKTOP HEADER (hidden on small screens, visible on lg+):
             Logo (left), Nav (center), Phone link (right)
        */}
        <div className="d-none d-lg-flex align-items-center">
          <Navbar.Brand href="#home" className="me-auto">
            <img
              src={Logo}
              width="350"
              alt="logo"
            />
          </Navbar.Brand>

          {/* Phone on right for large screens */}
          {/* <Nav className="ms-auto">
            <Nav.Link href="tel:+14807965133" className="nav-link">
              (480) 796-5133
            </Nav.Link>
          </Nav> */}
        </div>

        {/* 
          -- Actual Nav Collapse: 
             Only toggles open/close on mobile. 
             On desktop, it's always visible, 
             but you can hide the phone link here if you prefer to keep it in the "d-none d-lg-flex" row above.
        */}
        <Navbar.Collapse id="basic-navbar-nav" className="mt-2 mt-lg-0">
          <Nav className="ms-auto">
            {/* <Nav.Link href="#artists" className="nav-link" onClick={handleNavClick}>
              Artists
            </Nav.Link> */}
            <Nav.Link href="#events" className="nav-link" onClick={handleNavClick}>
              Events
            </Nav.Link>
            {/* <Nav.Link href="#kidsclasses" className="nav-link" onClick={handleNavClick}>
              Kid's Classes
            </Nav.Link> */}
            <BookButton className="nav-link"/>

            {/* Optionally hide phone link from here if you're showing it above */}
            <Nav.Link
              href="tel:+14807965133"
              className="nav-link" onClick={handleNavClick}
            >
              (480) 796-5133
            </Nav.Link>

            {/* <Button variant="primary" onClick={() => {
              onOpenModal();
              handleNavClick();
            }}>
              Request an Estimate
            </Button> */}

          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar >
  );
};

export default NavHeader;